
import { MemberRole, MemberPermission } from '../../types/memberTypes';

// Default permissions
const DEFAULT_PERMISSIONS: MemberPermission[] = [
  { id: 'viewOnly', name: 'View Only', checked: false },
  { id: 'portfolioSettings', name: 'Portfolio Settings', checked: false },
  { id: 'portfolioUsers', name: 'Portfolio Users', checked: false },
  { id: 'businessSettings', name: 'Business Settings', checked: false },
  { id: 'businessUsers', name: 'Business Users', checked: false }
];

// Get default permissions based on role
export const getPermissionsByRole = (role: MemberRole): MemberPermission[] => {
  switch (role) {
    case 'Primary Owner':
    case 'Owner':
      return DEFAULT_PERMISSIONS.map(p => ({ ...p, checked: true }));
    case 'Manager':
      return DEFAULT_PERMISSIONS.map(p => ({
        ...p,
        checked: p.id !== 'viewOnly' // Manager can do everything except view only
      }));
    default:
      return DEFAULT_PERMISSIONS;
  }
};

export const useFormPermissions = () => {
  // Utility function to update a permission in a permissions array
  const updatePermission = (
    permissions: MemberPermission[], 
    permissionId: string, 
    checked: boolean
  ): MemberPermission[] => {
    return permissions.map(p => {
      if (p.id === permissionId) {
        return { ...p, checked };
      }
      return p;
    });
  };
  
  return {
    getPermissionsByRole,
    updatePermission,
    DEFAULT_PERMISSIONS
  };
};
